
















import {
    Component, Inject, Model, Prop, Vue,
} from 'vue-property-decorator';
import AnalyticSteps from '../../dashboard/analytics/AnalyticSteps.vue';
import { ProductTemplateContent } from '@/assets/interface/Product';
// import { Validator } from 'vee-validate';AnalyticSteps

@Component
export default class RecTextField extends Vue {
    @Model('input') public model!: any;

    @Prop({ default: 'LABEL' }) public label!: string;

    @Prop({ default: 'text' }) public type!: string;

    @Prop({ default: 'text' }) public errorMessages!: string;

    @Prop({ default: '' }) public appendIcon!: string;

    public showPassword = false;
}
